module.exports = __webpack_public_path__ + "src/img/empty.1a71765f.png";